<div style="text-align: left; margin-bottom: 10px; margin-top: 10px;" *ngIf="isDisplay">
  <em class="error-msg">
    {{ message }}
  </em>
</div>
